import styles from "./ConsultingDetail.module.css";
import SubPageTop from "../../components/SubPageTop";
import ScrollReveal from "../../components/Ui/ScrollReveal";

import { FiFlag } from "react-icons/fi";

const imageProcessData = [
  {
    id: 1,
    step: "사전 상담",
    title: "사전 상담 및 열굴 진단",
    description:
      "컨설팅 목적 상담 및 얼굴 사진을 미리 전달하여 사전 이미지 체크",
    isActive: false,
    showArrow: false,
  },
  {
    id: 2,
    step: "방문 컨설팅",
    title: "퍼스널컬러 & 이미지스케일 진단을 통한 스타일제안",
    descriptions: [
      "드레이프를 활용하여 가장 어울리는 컬러와 미/일 톡허밀로 Taste Image Scale 진단",
      "개인의 체형, 패션스타일, 악세사리, 메이크업, 헤어 등 토탈 뷰티 스타일 제안",
    ],
    isActive: false,
    showArrow: false,
  },
  {
    id: 3,
    step: "사후관리",
    title: "컨설팅 보고서 제공",
    description: "컨설팅 완료 후 메일, SNS를 통해 결과를 전송",
    isActive: false,
    showArrow: true,
  },
  {
    id: 4,
    step: "",
    title:
      "라이프 스타일과 비즈니스 컨셉에 따른 컬러 이미지메이킹 제안을 통해 퍼스널 브랜딩 전략에 적용 가능",
    titleHighlight: "이미지메이킹",
    description: "",
    isActive: true,
    icon: FiFlag,
    showArrow: false,
  },
];

function PersonalImage() {
  return (
    <div className={styles.consultingDetail}>
      <SubPageTop title="Consulting" />
      <div className={styles.consultingDetailContent}>
        <ScrollReveal>
          <section className={styles.section01}>
            <div className={styles.imgbox}>
              <img
                src="/image/consulting-detail-section01-08.png"
                alt="컬러 이미지"
              />
            </div>
            <div className={styles.infoBox}>
              <div className={styles.infoHeader}>
                <p className={styles.subtitle}>Color Consulting</p>
                <p className={styles.koTitle}>이미지 컨설팅</p>
              </div>
              <div className={styles.infoDetail}>
                <div className={styles.infoDesc}>
                  이미지 컨설팅은,
                  <br />
                  직업 및 TPO에 맞는 개개인의 목표 이미지를 설정하여 실제로
                  구현해내는 컨설팅 서비스입니다.
                </div>
                {/*   <ul className={styles.infoList}>
                                  <li>
                                      <span className={styles.pointcolor}>·</span>
                                      <span>브랜드 및 기관의 정체성과 이미지 확립에 바람직한 도움이 되고자 건축물 및 조경환경을 대상으로 하는 색채 사용 기준 제시</span>
                                  </li>
                                  <li>
                                      <span className={styles.pointcolor}>·</span>
                                      <span>
                                          색채의 활용으로 차별화 된 환경 디자인의 기준을 마련하며, 지향 이미지를 바탕으로 향후 계획에 필요한 색채 팔레트 메뉴얼 제안
                                      </span>
                                  </li>
                                  <li>
                                      <span className={styles.pointcolor}>·</span>
                                      <span>심미성, 편리성, 생활을 고려한 환경 색채디자인으로 건물, 공간 및 브랜드에 대한 긍정적 이미지 부여 및 쾌적성, 편리성, 안정성을 도모하여 심리적 편안함 제공</span>
                                  </li>
                              </ul> */}
              </div>
            </div>
          </section>
        </ScrollReveal>
        <ScrollReveal>
          <section className={styles.section02}>
          <div className={styles.titleWrap}>
            <p className={styles.programSubtitle}>process</p>
            <h2 className={styles.title}>컨설팅 프로세스</h2>
          </div>
          <div className={styles.line}></div>
          <div className={styles.imageWrapper}>
            {imageProcessData.map((item) => {
              const Icon = item.icon;
              return (
                <div key={item.id} className={styles.imageProcessItem}>
                  <div className={styles.imageProcessContent}>
                    <div
                      className={`${styles.imageCircle} ${
                        item.isActive ? styles.imageCircleActive : ""
                      }`}
                    >
                      {Icon ? (
                        <Icon className={styles.imageCircleIcon} />
                      ) : (
                        <span className={styles.imageCircleText}>
                          {item.step}
                        </span>
                      )}
                    </div>
                    <div className={styles.imageContent}>
                      <h3 className={styles.imageTitle}>
                        {item.titleHighlight ? (
                          <>
                            {item.title.split(item.titleHighlight)[0]}
                            <span className={styles.imageTitleHighlight}>
                              {item.titleHighlight}
                            </span>
                            {item.title.split(item.titleHighlight)[1]}
                          </>
                        ) : (
                          item.title
                        )}
                      </h3>
                      {item.description && (
                        <p className={styles.imageDesc}>{item.description}</p>
                      )}
                      {item.descriptions && (
                        <ul className={styles.imageDescList}>
                          {item.descriptions.map((desc, idx) => (
                            <li key={idx}>{desc}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                  {item.showArrow && (
                    <div className={styles.imageArrow}>
                      <img src="/image/arrow_right.png" alt="arrow" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </section>
        </ScrollReveal>
      </div>
    </div>
  );
}

export default PersonalImage;
